import React from 'react';

interface SupportThankYouProps {
}

const SupportThankYou: React.FC<SupportThankYouProps> = () => {

    return (
      <>
        <div className="modal fade" id="thank-you" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content py-5 px-3 mt-4">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span>Close</span>
                        <img src="https://www.nowtv.now.com/wp-content/themes/wmx/images//icons/mw-remove.png" alt="" />
                    </button>
                    <div className="modal-body text-center pb-5 px-0">
                        <div>
                            <h2>Thanks for your feedback!</h2>
                            <p>Your comments will really help.</p>
                        </div>
                        <div className="mt-5">
                            <a href="#" className="mx-3 default-btn thinner barlow-font" data-dismiss="modal">Close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
};

export default SupportThankYou;